export const DEFAULT_CENTER = [32.0853, 34.7818];

export const DEFAULT_LAYERS = {
  vesselPosition: true,
  gpsAccuracy: true,
  courseLine: false,
  headingLine: false,
  bearingLine: false,
  waypoints: true,
  route: true,
  distanceRings: false,
  seamarks: true,
  marinas: true,
  grid: true,
  bathymetry: false,
  weather: false,
  soundings: false,
  buoys: true,
  beacons: true,
  lights: true,
  restrictedAreas: false,
  trafficSeparation: false,
  currentDepth: false,
  underKeel: false,
  tidalData: false,
  currents: false,
  aisTargets: false,
  aisLabels: false,
  cpaTcpa: false,
  collisionAlerts: true,
  anchorWatch: false,
  hazardWarnings: false,
  wind: false,
  vmg: false,
  performanceTools: false,
  speedOnMap: false,
};

export const LAYER_GROUPS = [
  {
    title: "Navigation",
    layers: [
      { key: "seamarks", label: "Navigation aids", description: "OpenSeaMap buoys, lights and markers" },
      { key: "marinas", label: "Marinas", description: "Marstick marina database" },
      { key: "grid", label: "Lat / Lon grid", description: "Coordinate reference overlay" },
    ],
  },
  {
    title: "Safety",
    layers: [
      { key: "bathymetry", label: "Depth planning", description: "Light planning tint for depth awareness" },
      { key: "weather", label: "Weather panel", description: "Marine weather summary" },
    ],
  },
  {
    title: "Route",
    layers: [
      { key: "route", label: "Route planner", description: "Click the map to add waypoints" },
    ],
  },
];

const EARTH_RADIUS_NM = 3440.065;

function toRad(value) {
  return (value * Math.PI) / 180;
}

export function distanceNm(a, b) {
  if (!a || !b) return 0;
  const dLat = toRad(b[0] - a[0]);
  const dLng = toRad(b[1] - a[1]);
  const lat1 = toRad(a[0]);
  const lat2 = toRad(b[0]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_NM * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
}

export function routeDistance(points) {
  return points.reduce((total, point, index) => index === 0 ? total : total + distanceNm(points[index - 1], point), 0);
}

export function formatCoord(value, axis) {
  const direction = axis === "lat" ? (value >= 0 ? "N" : "S") : value >= 0 ? "E" : "W";
  return `${Math.abs(value).toFixed(5)}° ${direction}`;
}

export function buildGpx(points) {
  const route = points.map(([lat, lng], index) => `    <rtept lat="${lat}" lon="${lng}"><name>WP ${index + 1}</name></rtept>`).join("\n");
  return `<?xml version="1.0" encoding="UTF-8"?>\n<gpx version="1.1" creator="Marstick" xmlns="http://www.topografix.com/GPX/1/1">\n  <rte>\n    <name>Marstick Route</name>\n${route}\n  </rte>\n</gpx>`;
}